export const auraWordingList = () => {
	return [
		{
			auraExclusionCode: "ACCDEA",
			riskTypeCode: "LAD",
			exclusionWording:
				"The benefit under this policy is only payable where death occurs as a direct or indirect result of Accidental Death. No benefit will be payable where the death occurred as a result of a self-inflicted injury.  Accidental Death means death as a result of sustaining bodily injury caused by accidental, violent, external and visible means while your policy is current. It does not cover you for any sickness related events.",
		},
		{
			auraExclusionCode: "ABASEJ",
			riskTypeCode: "LAD",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of BASE Jumping.",
		},
		{
			auraExclusionCode: "ABASEJ",
			riskTypeCode: "LIF",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of BASE Jumping.",
		},
		{
			auraExclusionCode: "ABASEJ",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of BASE Jumping.",
		},
		{
			auraExclusionCode: "ABOXIN",
			riskTypeCode: "CI ",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Boxing (other than participating in boxercise classes or group classes).",
		},
		{
			auraExclusionCode: "ABOXIN",
			riskTypeCode: "LAD",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Boxing (other than participating in boxacise classes or group classes).",
		},
		{
			auraExclusionCode: "ABOXIN",
			riskTypeCode: "LIF",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Boxing (other than participating in boxercise classes or group classes).",
		},
		{
			auraExclusionCode: "ABOXIN",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Boxing (other than participating in boxercise classes or group classes).",
		},
		{
			auraExclusionCode: "ACADIV",
			riskTypeCode: "LAD",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Cave Diving or Wreck Diving.",
		},
		{
			auraExclusionCode: "ACADIV",
			riskTypeCode: "LIF",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Cave Diving or Wreck Diving.",
		},
		{
			auraExclusionCode: "ACADIV",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Cave Diving or Wreck Diving.",
		},
		{
			auraExclusionCode: "ACLIDI",
			riskTypeCode: "LAD",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Cliff Diving.",
		},
		{
			auraExclusionCode: "ACLIDI",
			riskTypeCode: "LIF",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Cliff Diving.",
		},
		{
			auraExclusionCode: "ACLIDI",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Cliff Diving.",
		},
		{
			auraExclusionCode: "ACLIMB",
			riskTypeCode: "LAD",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Mountain Climbing, Abseiling, Rock Climbing, Ice Climbing and/or Caving.",
		},
		{
			auraExclusionCode: "ACLIMB",
			riskTypeCode: "LIF",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Mountain Climbing, Abseiling, Rock Climbing, Ice Climbing and/or Caving.",
		},
		{
			auraExclusionCode: "ACLIMB",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Mountain Climbing, Abseiling, Rock Climbing, Ice Climbing and/or Caving.",
		},
		{
			auraExclusionCode: "AFLYIN",
			riskTypeCode: "LAD",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Flying (other than as a fare paying passenger, or as your primary occupation ie, pilot, flight attendant).",
		},
		{
			auraExclusionCode: "AFLYIN",
			riskTypeCode: "LIF",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Flying (other than as a fare paying passenger, or as your primary occupation i.e., pilot, flight attendant).",
		},
		{
			auraExclusionCode: "AFLYIN",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Flying (other than as a fare paying passenger, or as your primary occupation i.e., pilot, flight attendant).",
		},
		{
			auraExclusionCode: "AHERNI",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder related to hernias including any complications arising from treatment.",
		},
		{
			auraExclusionCode: "AMOTOR",
			riskTypeCode: "LAD",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Motor Racing (including Motorcycle Racing).",
		},
		{
			auraExclusionCode: "AMOTOR",
			riskTypeCode: "LIF",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Motor Racing (including Motorcycle Racing).",
		},
		{
			auraExclusionCode: "AMOTOR",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Motor Racing (including Motorcycle Racing).",
		},
		{
			auraExclusionCode: "ARKFIS",
			riskTypeCode: "LAD",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Rock Fishing.",
		},
		{
			auraExclusionCode: "ARKFIS",
			riskTypeCode: "LIF",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Rock Fishing.",
		},
		{
			auraExclusionCode: "ARKFIS",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Rock Fishing.",
		},
		{
			auraExclusionCode: "ASCUBA",
			riskTypeCode: "CI ",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Scuba Diving to a depth greater than 40 metres.",
		},
		{
			auraExclusionCode: "ASCUBA",
			riskTypeCode: "LAD",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Scuba Diving to a depth greater than 40 metres.",
		},
		{
			auraExclusionCode: "ASCUBA",
			riskTypeCode: "LIF",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Scuba Diving to a depth greater than 40 metres.",
		},
		{
			auraExclusionCode: "ASCUBA",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Scuba Diving to a depth greater than 40 metres.",
		},
		{
			auraExclusionCode: "ASKDI ",
			riskTypeCode: "LAD",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Skydiving.",
		},
		{
			auraExclusionCode: "ASKDI ",
			riskTypeCode: "LIF",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Skydiving.",
		},
		{
			auraExclusionCode: "ASKDI ",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Life Insured engaging in any form of Skydiving.",
		},
		{
			auraExclusionCode: "LUNG  ",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim \noccurs as a direct or indirect result of any disease or disorder of the lungs or chest wall resulting in pneumothorax or any complications arising from \ntreatment.",
		},
		{
			auraExclusionCode: "MCANCE",
			riskTypeCode: "CI ",
			exclusionWording:
				"No benefit will be payable under this cover if the Life Insured suffers from Cancer as defined in the definition of Critical Illness.",
		},
		{
			auraExclusionCode: "MCHFAT",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Chronic Fatigue Syndrome.",
		},
		{
			auraExclusionCode: "MDIVER",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Diverticulitis.",
		},
		{
			auraExclusionCode: "MGLAUC",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim \noccurs as a direct or indirect result of any disease or disorder of the eyes including any complications arising from treatment thereof.",
		},
		{
			auraExclusionCode: "MHERNI",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Hiatus Hernia.",
		},
		{
			auraExclusionCode: "MMEILL",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any mental or nervous disease or disorder including, but not limited to: Anxiety, Depression, Stress, Chronic Fatigue Syndrome, Post Traumatic Stress Disorder, Exhaustion or Fibromyalgia, Physical Complication of Psychiatric Disorders, Drug, Alcohol or Substance Abuse, Cognitive Impairment, Behavioural Disorders or any complications thereof.",
		},
		{
			auraExclusionCode: "MOESOP",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder of the Oesophagus or any complication thereof.",
		},
		{
			auraExclusionCode: "MSCL  ",
			riskTypeCode: "CI ",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim \noccurs as a direct or indirect result of any disease or disorder related to Multiple Sclerosis including complications or complications arising from \ntreatment thereof.",
		},
		{
			auraExclusionCode: "MSCL  ",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim \noccurs as a direct or indirect result of any disease or disorder related to Multiple Sclerosis including complications or complications arising from \ntreatment thereof.",
		},
		{
			auraExclusionCode: "MSLPAP",
			riskTypeCode: "CI ",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Sleep Apnoea.",
		},
		{
			auraExclusionCode: "MSLPAP",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Sleep Apnoea.",
		},
		{
			auraExclusionCode: "MSUIC5",
			riskTypeCode: "LIF",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of the Suicide or an attempted Suicide by the Life Insured (whether sane or insane) within 5 years of the policy commencement date or the most recent reinstatement of the policy.",
		},
		{
			auraExclusionCode: "MUTPRO",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to the uterus including complications related to treatment. ",
		},
		{
			auraExclusionCode: "PAHEEL",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Achilles Heel.",
		},
		{
			auraExclusionCode: "PBACKP",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Spine, the Vertebrae, Intervertebral Discs, Nerve Roots, Ligaments or supporting Musculature, including Sciatica or any complication thereof.",
		},
		{
			auraExclusionCode: "PBANKL",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of both the Right and Left Ankles. ",
		},
		{
			auraExclusionCode: "PBELBO",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of both the Right and Left Elbows. ",
		},
		{
			auraExclusionCode: "PBELLS",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Bell's Palsy.",
		},
		{
			auraExclusionCode: "PBFEET",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of both the Right and Left Feet. ",
		},
		{
			auraExclusionCode: "PBHAND",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of both the Right and Left Hands. ",
		},
		{
			auraExclusionCode: "PBJAW ",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Jaw. ",
		},
		{
			auraExclusionCode: "PBKNEE",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of both the Right and Left Knees. ",
		},
		{
			auraExclusionCode: "PBLIND",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Blindness.",
		},
		{
			auraExclusionCode: "PBOARM",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of both the Right and Left Arms. ",
		},
		{
			auraExclusionCode: "PBOLEG",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of both the Right and Left Legs. ",
		},
		{
			auraExclusionCode: "PBSHOU",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of both the Right and Left Shoulders and/or Collarbones. ",
		},
		{
			auraExclusionCode: "PBWRIS",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of both the Right and Left Wrists. ",
		},
		{
			auraExclusionCode: "PCARPT",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Carpel Tunnel Syndrome.",
		},
		{
			auraExclusionCode: "PCATAR",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Cataracts.",
		},
		{
			auraExclusionCode: "PCONJU",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Conjunctivitis.",
		},
		{
			auraExclusionCode: "PDEAFN",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Deafness.",
		},
		{
			auraExclusionCode: "PDISCS",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Spine, the Vertebrae, Intervertebral Discs, Nerve Roots, Ligaments or supporting Musculature, including Sciatica or any complication thereof.",
		},
		{
			auraExclusionCode: "PFSPIN",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Spine, the Vertebrae, Intervertebral Discs, Nerve Roots, Ligaments or supporting Musculature, including Sciatica or any complication thereof.",
		},
		{
			auraExclusionCode: "PLANKL",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Left Ankle. ",
		},
		{
			auraExclusionCode: "PLEARM",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Left Arm. ",
		},
		{
			auraExclusionCode: "PLELBO",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Left Elbow. ",
		},
		{
			auraExclusionCode: "PLELEG",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Left Leg. ",
		},
		{
			auraExclusionCode: "PLFOOT",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Left Foot. ",
		},
		{
			auraExclusionCode: "PLHAND",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Left hand. ",
		},
		{
			auraExclusionCode: "PLKNEE",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Left Knee. ",
		},
		{
			auraExclusionCode: "PLSHOU",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Left Shoulder and/or Left Collarbone. ",
		},
		{
			auraExclusionCode: "PLWRIS",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Left Wrist. ",
		},
		{
			auraExclusionCode: "PMENIE",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Meniere's Disease.",
		},
		{
			auraExclusionCode: "POSTEO",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Osteoarthritis.",
		},
		{
			auraExclusionCode: "PRANKL",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Right Ankle. ",
		},
		{
			auraExclusionCode: "PRELBO",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Right Elbow. ",
		},
		{
			auraExclusionCode: "PRETIN",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Retinitis, Detached Retina, or Retinal Haemorrhage.",
		},
		{
			auraExclusionCode: "PRFOOT",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Right Foot. ",
		},
		{
			auraExclusionCode: "PRHAND",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Right Hand. ",
		},
		{
			auraExclusionCode: "PRIARM",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Right Arm. ",
		},
		{
			auraExclusionCode: "PRILEG",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Right Leg. ",
		},
		{
			auraExclusionCode: "PRKNEE",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Right Knee. ",
		},
		{
			auraExclusionCode: "PRSHOU",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Right Shoulder and/or Right Collarbone. ",
		},
		{
			auraExclusionCode: "PRWRIS",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any injury to or disease or disorder of the Right Wrist. ",
		},
		{
			auraExclusionCode: "PTENDO",
			riskTypeCode: "PUW",
			exclusionWording:
				"No benefit will be payable under this cover if the event that gives rise to a claim occurs as a direct or indirect result of any disease or disorder pertaining to Tendonitis.",
		},
		{
			auraExclusionCode: "REPBUS",
			riskTypeCode: "CI ",
			exclusionWording:
				"Your application for cover under this policy has been accepted on the basis that it replaces existing cover as advised by you. No claim will be paid under this policy if you fail to cancel the existing cover as declared.",
		},
		{
			auraExclusionCode: "REPBUS",
			riskTypeCode: "LIF",
			exclusionWording:
				"Your application for cover under this policy has been accepted on the basis that it replaces existing cover as advised by you. No claim will be paid under this policy if you fail to cancel the existing cover as declared.",
		},
		{
			auraExclusionCode: "REPBUS",
			riskTypeCode: "PUW",
			exclusionWording:
				"Your application for cover under this policy has been accepted on the basis that it replaces existing cover as advised by you. No claim will be paid under this policy if you fail to cancel the existing cover as declared.",
		},
	];
};
